import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import 'assets/login.css';
import { userLogin } from 'store/auth/auth';

export const UserLogin1 = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const authError = useSelector((state) => state.auth.authError);

  const onSubmit = (data) => {
    dispatch(userLogin(data));
  };

  return (
    <div className='flex-div'>
      <form onSubmit={handleSubmit(onSubmit)} id='loginUser'>
        <h2 style={{ textAlign: 'center', paddingBottom: '15px' }}>{t('login.user_title')}</h2>
        {authError && <div style={{ color: '#e93030', paddingBottom: '15px' }}>{authError}</div>}
        <input
          {...register('username', { required: true })}
          aria-invalid={errors.firstName ? 'true' : 'false'}
        />
        {errors.username?.type === 'required' && <p role='alert'>Username is required</p>}

        <input
          {...register('password', { required: 'Password is required' })}
          aria-invalid={errors.password ? 'true' : 'false'}
        />
        {errors.password && <p role='alert'>{errors.password?.message}</p>}

        <input type='submit' />
      </form>
    </div>
  );
};
